import { _ } from '@ngx-translate/core';
import { FlowUnit } from '@app/shared/units/flow/flow-unit.enum';

export const flowUnitLocalize: Record<FlowUnit, string> = {
  [FlowUnit.LitresPerSecond]: _(`@@shared-leak-size-unit__litres-per-second`),
  [FlowUnit.GallonsPerSecond]: _(`@@shared-leak-size-unit__gallons-per-second`),
};

/** the unit the API stores a leak size in, and the field's default */
export const DEFAULT_FLOW_UNIT = FlowUnit.LitresPerSecond;
